module.exports = __webpack_public_path__ + "static/media/IMG-20230508-WA0172.bf39d11b.jpg";